/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "CreditFundsRequest": {
                "fields": {
                  "creditLineToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  }
                }
              },
              "CreditFundsResponse": {
                "fields": {}
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreditFundsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreditFundsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreditFundsRequest @ squareup/corporate_card/service/credit_funds.proto at 8:1
 */
export const CreditFundsRequest = $root.lookupType('squareup.corporate_card.service.CreditFundsRequest');
fixType(CreditFundsRequest, {
  creditLineToken: {
    required: true
  }
});
Builder.createAndAttachToType(CreditFundsRequest);
/**
 * SOURCE CreditFundsResponse @ squareup/corporate_card/service/credit_funds.proto at 15:1
 */
export const CreditFundsResponse = $root.lookupType('squareup.corporate_card.service.CreditFundsResponse');
fixType(CreditFundsResponse);
Builder.createAndAttachToType(CreditFundsResponse);